/**
 * postMessage contract between the Freshservice auth popup
 * (`/freshservice/auth/start`) and the panel's `FreshserviceAuthGate`.
 * Both sides are the Magnus origin — the gate verifies `event.origin`
 * against `window.location.origin` before trusting the payload.
 */

export const FRESHSERVICE_AUTH_MESSAGE_TYPE = "magnus-freshservice-auth";

export type FreshserviceAuthMessage = {
  type: typeof FRESHSERVICE_AUTH_MESSAGE_TYPE;
  sessionToken: string;
};

export function isFreshserviceAuthMessage(
  data: unknown
): data is FreshserviceAuthMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as { type?: unknown }).type === FRESHSERVICE_AUTH_MESSAGE_TYPE &&
    typeof (data as { sessionToken?: unknown }).sessionToken === "string"
  );
}
